import { useState } from 'react';

import { ModalRoot, Modal, ModalHeader, ModalContent, ModalFooter, Button, TextInput } from '@pella/sash-framework';

import * as classes from './ConfirmDeleteModal.module.css';

/**
 * ConfirmDeleteModal Molecule Component
 * @param {Local.ConfirmDeleteModalProps} props - Component props
 */
export const ConfirmDeleteModal = ({ isOpen, description, onConfirm, onCancel, strictMessage }) => {
  const [confirmInput, setConfirmInput] = useState('');

  const disableConfirm = strictMessage ? confirmInput !== description : false;

  /** Handle cancel action */
  const handleCancel = () => {
    setConfirmInput('');
    onCancel();
  };

  /** Handle confirm action */
  const handleConfirm = () => {
    setConfirmInput('');
    onConfirm();
  };

  /**
   * Handle changes to the confirm input field.
   * @param {React.ChangeEvent<HTMLInputElement>} e - The change event from the confirm input field
   */
  const handleConfirmInputChange = (e) => {
    setConfirmInput(e.target.value);
  };

  return (
    <ModalRoot open={isOpen}>
      <Modal className={classes.container} showClose={false}>
        <ModalHeader>Confirm Deletion</ModalHeader>
        <ModalContent>
          <p>
            <b>{description}</b>
          </p>
          Are you sure you want to delete this item? This action cannot be undone.
          {strictMessage && (
            <div className={classes.strictInput}>
              <div className={classes.warning}>WARNING!</div>
              <p>{strictMessage}</p>
              <p>Ensure you understand the consequences before proceeding.</p>
              <TextInput
                id='confirmDeleteInput'
                data-testid={`confirmDeleteInput-${description}`}
                labelText=''
                value={confirmInput}
                assistiveText={`Type "${description}" to confirm`}
                placeholder='Type to confirm'
                onChange={handleConfirmInputChange}
              />
            </div>
          )}
        </ModalContent>
        <ModalFooter className={classes.modalFooter}>
          <Button color='secondary' onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            color='primary'
            onClick={handleConfirm}
            disabled={disableConfirm}
            data-testid={`confirmDeleteButton-${description}`}
          >
            Confirm
          </Button>
        </ModalFooter>
      </Modal>
    </ModalRoot>
  );
};
